
<template>

  <div class="atividades-rfilancamentos ml-4 mr-4" >
      <b-form>          
          <b-row>
              <b-col cols="6">
                <label for="select-empresa">Empresa</label> 
                <multiselect  id="selecao-empresa-sol"  v-model="value_empresa" required                  
                  :options="empresas" 
                  :multiple="true"
                  :close-on-select="false"
                  :clear-on-select="false"                   
                  :preserve-search="true" placeholder="Selecione a empresa" label="empresa" track-by="empresa" name="empresa"
                  :preselect-first="true">                  
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Empresa selecionada</span></template>
                </multiselect> 
              </b-col>
<!--
              <b-col cols="3">
                <label for="select-filial-lin">Filial</label> 
                <multiselect id="selecao-filial-lin"  v-model="value_filial" 
                  required                   
                  :options="filiais" 
                  :multiple="true" 
                   :taggable="true"                
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione a filial" label="filial" track-by="filial" name="filial"
                  :preselect-first="true">
                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Filial selecionada</span></template>
                </multiselect> 
              </b-col>
               -->

                            <b-col cols="2">
                <label for="select-situacao">Situação</label> 
                <multiselect id="selecao-situcao-sol"  v-model="value_situacao" required                   
                  :options="statuss" 
                  :multiple="true" 
                   :taggable="true"                   
                   @close="loadVeiculos()"
                  :close-on-select="false" 
                  :clear-on-select="false" 
                  :preserve-search="true"   placeholder="Selecione o status" label="status" track-by="status" name="status"
                  :preselect-first="true">                
                  <template slot="selection" slot-scope="{ values,isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} Status selecionada</span></template>
                </multiselect> 
              </b-col>

              <LoadingModal v-if="isLoading" />

              <b-col cols="3" >
                <label  for="input-busca">Pesquisa no grid  </label>  
                <b-form-input id="buscamonitoramento" v-model="search"  required="required" placeholder="Razão Social / CNPJ"></b-form-input>              
              </b-col>                 


              <b-col cols="1">
                <br>
                <b-button variant="warning"  block class="mt-2 mr-2 " v-b-modal.ModaleditarFuncionario >Novo</b-button>
              </b-col>

          </b-row>
    </b-form>

    
    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>    
    <!--tbl de dados -->
        <b-table small hover striped sticky-header="100%"  :items="itemsFiltered" :fields="fieldsCliFor">                  
        <template slot="cell(actions)" slot-scope="data">
          <b-button  @click="putFunc(data.item)"    title="Editar cadastro"  size="sm" variant="primary" class="mr-2 mt-2" v-b-modal.ModaleditarFuncionario>                
            <i class="fa fa-pencil"></i>              
          </b-button> 
        </template>
    </b-table>
    <b-pagination size="xl" v-model="page" :total-rows="count" :per-page="limitcarro"></b-pagination>
    

      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
      <div>        
    <b-modal id="ModaleditarFuncionario" centered cancel-title="Fechar"  @cancel="loadCliGrid()"  @close="loadCliGrid()" hide-footer size="xl" title="Cadastro"  no-close-on-esc no-close-on-backdrop>
          <!-- -->
          <div>

          

            <b-row> 
              <!--

              <b-col cols="7">
                <label for="input-filial">Empresa</label> 
                <div>                
                  <b-form-select   
                    id="fun-empresa"               
                    v-model="resultadocnpj.id_empresa"                    
                    required                                                   CNPJ
                    :options="empresas"
                    class="mb-3 "
                    text-field="empresa" 
                    @change="loadFiliais()"                                           
                  >                
                  </b-form-select>
                </div>
              </b-col>


              <b-col cols="5">
              <label for="input-filial">Filial</label>
              <div>                
                <b-form-select   
                  id="fun-filial"               
                  v-model="resultadocnpj.id_filial"                    
                  required                                                   
                  :options="filiais"
                  class="mb-3 "
                  text-field="filial"                                            
                >                
                </b-form-select>
              </div>            
            </b-col>
-->

            
            <b-col cols="3"  class="mb-2 mt-6">
                <label for="input-registro">CNPJ</label> 
                <b-form-input  @keyup.enter="loadCliFor()" v-model="resultadocnpj.cnpj" required placeholder="Nº do CNPJ" v-b-tooltip.hover title="Digite o prefixo do clifor"></b-form-input>              
            </b-col>             

<b-col cols="5"  class="mb-2">
    <label for="input-live">RAZÃO SOCIAL</label>  
    <b-form-input v-model="resultadocnpj.nome" placeholder="Digite a razão social da empresa"></b-form-input>              
</b-col>

           <b-col cols="4"  class="mb-2">
                <label for="input-live">NOME FANTASIA</label> 
                <b-form-input v-model="resultadocnpj.fantasia" placeholder=""></b-form-input>              
            </b-col>
            
            
            <!--

                          <b-col cols="2 ">
                <div>                            
                  <label  for="datepicker-placeholder">Data de abertura</label>                        
                  <b-form-datepicker id="dt_sol_inicial"  required  v-model="resultadocnpj.abertura" placeholder="Data inicial " locale="pt-BR" date-format-options="DD/MM/YYYY"></b-form-datepicker>
                </div>                     
              </b-col>
              -->

<!-- endereço  -->
            <b-col cols="6"  class="mb-2 mt-6">
                <label for="input-registro">LOGRADOURO</label> 
                <b-form-input v-model="resultadocnpj.logradouro" required placeholder="Informe o endereço" v-b-tooltip.hover title="Informe o endereço"></b-form-input>              
            </b-col>             

<b-col cols="2"  class="mb-2">
    <label for="input-live">NUMERO</label>  
    <b-form-input v-model="resultadocnpj.numero" placeholder="Digite o número"></b-form-input>              
</b-col>

           <b-col cols="4"  class="mb-2">
                <label for="input-live">COMPLEMENTO</label> 
                <b-form-input v-model="resultadocnpj.complemento" placeholder="Digite o nome fantasia"></b-form-input>              
            </b-col>



<!-- bairoo  -->
            <b-col cols="4"  class="mb-2 mt-6">
                <label for="input-registro">BAIRRO</label> 
                <b-form-input v-model="resultadocnpj.bairro" required placeholder="informe o bairro" v-b-tooltip.hover title="Informe o bairro"></b-form-input>              
            </b-col>             

<b-col cols="5"  class="mb-2">
    <label for="input-live">MUNICIPIO</label>  
    <b-form-input v-model="resultadocnpj.municipio" placeholder="Digite o número"></b-form-input>              
</b-col>

           <b-col cols="1"  class="mb-2">
                <label for="input-live">UF</label> 
                <b-form-input v-model="resultadocnpj.uf" placeholder="UF"></b-form-input>              
            </b-col>

                       <b-col cols="2"  class="mb-2">
                <label for="input-live">CEP</label> 
                <b-form-input v-model="resultadocnpj.cep" placeholder="Digite o CEP"></b-form-input>              
            </b-col>



<!-- EMAIL  -->
            <b-col cols="4"  class="mb-2 mt-6">
                <label for="input-registro">EMAIL</label> 
                <b-form-input v-model="resultadocnpj.email" required placeholder=" E-mail" v-b-tooltip.hover title="Informe o nome"></b-form-input>              
            </b-col>             

            <b-col cols="4"  class="mb-2">
                <label for="input-live">SITE</label> 
                <b-form-input v-model="resultadocnpj.site" placeholder="Obs "></b-form-input>              
            </b-col>

<b-col cols="2"  class="mb-2">
    <label for="input-live">TELEFONE</label>  
    <b-form-input v-model="resultadocnpj.telefone" placeholder="Digite o número"></b-form-input>              
</b-col>

           <b-col cols="2"  class="mb-2">
                <label for="input-live">CELULAR</label> 
                <b-form-input v-model="resultadocnpj.celular" placeholder=""></b-form-input>              
            </b-col>


                          <b-col cols="4">
                <label for="input-status">AREA</label> 
                <div>                
                  <b-form-select                  
                    v-model="resultadocnpj.area_id"  
                    required                                                   
                    :options="areas"
                    class="mb-3"
                    text-field="area"                            
                  >                   
                  </b-form-select>
                </div>
              </b-col> 

              <b-col cols="4">
                <label for="input-status">TIPO</label> 
                <div>                
                  <b-form-select                  
                    v-model="resultadocnpj.tipo_id"  
                    required                                                   
                    :options="tipos"
                    class="mb-3"
                    text-field="tipo"                            
                  >                   
                  </b-form-select>
                </div>
              </b-col>            

              <b-col cols="4">
                <label for="input-status">ESCRITÓRIO</label> 
                <div>                
                  <b-form-select                  
                    v-model="resultadocnpj.escritorio_id"  
                    required                                                   
                    :options="escritorios"
                    class="mb-3"
                    text-field="escritorio"                            
                  >                   
                  </b-form-select>
                </div>
              </b-col>    


            </b-row> 

            <b-row   class=" mt-2 mb-2">                                    
        
            </b-row>   


            <b-row class="mt-2">

              <b-col cols="3">
                <label for="input-live">DATA CADASTRO</label>                 
                <b-input-group-text >{{ resultadocnpj.dt_cadastro !=null ? moment(resultadocnpj.dt_cadastro).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') : '-' }}</b-input-group-text>
              </b-col> 

              <b-col cols="3">
                <label for="input-live">DATA ALTERAÇÃO</label>                 
                <b-input-group-text >{{resultadocnpj.dt_cadastro !=null ? moment(resultadocnpj.dt_alteracao).format('DD/MM/YYYY HH:mm').replace('Data inválida','-') :'-' }}</b-input-group-text>
              </b-col> 


              
            <b-col cols="4"  class="mb-2">
                <label for="input-live">CONTATO</label> 
                <b-form-input v-model="resultadocnpj.contato" placeholder="Obs "></b-form-input>              
            </b-col>

             <b-col cols="2">
                <label for="input-live">RECEITA FEDERAL</label>                                 
                <b-input-group-text :style="getStyle">{{ resultadocnpj.situacao !=null ? resultadocnpj.situacao :'-'  }}</b-input-group-text>
              </b-col> 






            </b-row> 

             <b-button class="mt-3" variant="success" block  @click=" postclifors()">Gravar</b-button>
            
          </div>
          
        </b-modal>
      </div>
      <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>  

</template>


<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { mapState } from 'vuex' 
import LoadingModal from '../utilitarios/LoadingModal'

export default {

  computed : { ... mapState (['user'],),

      getStyle() {
      return {
        color: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'red' : '', // Fonte vermelha se não for 'ATIVA'
        background: this.resultadocnpj.situacao !== 'ATIVA' && this.resultadocnpj.situacao !=null ? 'yellow' : '', // Background amarelo se não for 'ATIVA'
      };
    },


  itemsFiltered(){
        let valorefu = [];       
        valorefu = this.resultadoCliFor.filter((item) =>{
          const nome = item.nome || ''; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
          const cnpj = item.cnpj || '';          
          return (
             nome.indexOf(this.search) >-1  ||             
             cnpj.indexOf(this.search) >-1 
          );
        });
        return valorefu
        }

  } ,

    name: 'FuncionarioCadastro',    

    data: function() {
      
        return {
          empresa:{}, 
          empresas:[],   // [] lista       
          filial:{}, 
          filiais: [],   // [] lista      
          clifors:[],
          clifor:{},          
          ceps:[],
          resultadoCliFor:[],
          resultadocnpj:{},
          value_cnpj:'',
          areas:[],
          tipos:[],
          escritorios:[],
          search:'',
/*
            mode: 'save',
            carregando: false,
            atualizando: false,              
            page: 1,
            limitcarro: 0,
            count: 0,
            valor_empresa:'',                                     
            selected: null,
  */          
            fieldsCliFor: [                
              { key: 'empresa_id', label: 'EMPRESA', sortable: true },                 
                { key: 'cnpj', label: 'CNPJ', sortable: true },                 
                { key: 'nome', label: 'RAZÃO SOCIAL', sortable: true },                       
                { key: 'municipio', label: 'MUNICIPIO', sortable: true },
                { key: 'uf', label: 'UF', sortable: true },
                { key: 'telefone', label: 'TELEFONE', sortable: true },
                { key: 'celular', label: 'CELULAR', sortable: true },
                { key: 'email', label: 'E-MAIL', sortable: true },
                { key: 'contato', label: 'CONTATO', sortable: true },
                { key: 'situacao', label: 'SITUAÇÃO RECEITA', sortable: true },
                { key: 'dt_cadastro', label: 'DATA CADASTRO', sortable: true, formatter: (value, key, itemsFiltered) => {
                    return moment(itemsFiltered.dt_cadastro).format('DD/MM/YYYY HH:MM').replace('Data inválida','-') ; }  },                
                { key: 'actions', label: 'Ações' },                
            ]
        }        
    },

    components: {
        Multiselect, LoadingModal
    },

    methods: {

      handleOk(bvModalEvent) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },

            loadEmpresas() {
            let corpo = {    
                "empresa_id": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/jb/controle/empresa`
          axios.post(url,corpo).then(res => {
            this.empresas = res.data.map(emp => {              
              return { id_empresa: emp.id_empresa, empresa: emp.empresa }
            })
          })
      },  



/*
      loadEmpresa() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa`
          axios.post(url,corpo)
          .then(res => {this.empresasf = res.data.map(emp => {return { ... emp, value: emp.id_empresa, empresa: emp.nomeempresarial, id_filial_erp: emp.id_filial_erp } })})
          .catch(showError)
      },
*/
/*
      loadFiliais() {
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_empresa}`,                                            
            };

          const url = `${baseApiUrl}/ctr/empresa/filial`
          axios.post(url,corpo)
            .then(res => {
              this.filiais = res.data.map(fil => {                      
                return { ... fil, value: fil.id_filial_erp, filial: fil.filial }  //// para pegar o valor tem que usar o ... atribuicao value
              })
            })
            .catch(showError)
        },
*/
        loadArea() {          
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };            
          const url = `${baseApiUrl}/jb/fin/area`
          axios.post(url,corpo)
          .then(res => {this.areas = res.data.map(emp => {return { ... emp, value: emp.id, area: emp.area} })})
          .catch(showError)
        },

        loadTipo() {          
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };            
          const url = `${baseApiUrl}/jb/fin/tipo`
          axios.post(url,corpo)
          .then(res => {this.tipos = res.data.map(emp => {return { ... emp, value: emp.id, tipo: emp.tipo} })})
          .catch(showError)
        },

        loadEscritório() {          
            let corpo = {    
                "id_grupo_empresa": `${this.user.id_grupo_empresa}`,                                            
            };            
          const url = `${baseApiUrl}/jb/fin/escritoriojur`
          axios.post(url,corpo)
          .then(res => {this.escritorios = res.data.map(emp => {return { ... emp, value: emp.id, area: emp.escritorio} })})
          .catch(showError)
        },


        async consultarCNPJ() {     
            
                  let corpo = {    
                        "cnpj": `${this.value_cnpj}`                
                    };

                  const url = await `${baseApiUrl}/cnpj`
                  axios.post(url,corpo)
                      .then(res => {this.resultadocnpj = res.data})                   
                      .catch(showError)                       
        },




        async loadCep() {  
          let corpo = {    
                "cep": `${this.clifors.cnpj}`                
            };
          const url = await`${baseApiUrl}/viacep`
          axios.post(url,corpo)
               .then(res => {this.ceps = res.data})         
              .catch(showError)                      
          
        }, 

      putFunc(resultadocnpj) {            
            this.resultadocnpj = { ...resultadocnpj }
      },

      async loadCliFor() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,   
            "cnpj": `${this.resultadocnpj.cnpj}`,            
            "filtro": 'porcnpj'
          };
          const url = await`${baseApiUrl}/jb/fin/clifor`
          axios.post(url,corpo)
               .then(res => {this.resultadocnpj = res.data})         
              .catch(showError)  
      }, 

      async loadCliGrid() {  
          let corpo = {    
            "empresa_id": `${this.user.id_empresa}`,
            "filtro": `${this.user.perfil_id}`,
            "filtro": 'listagemcf7'
          };
          const url = await`${baseApiUrl}/jb/fin/clifor`
          axios.post(url,corpo)
               .then(res => {this.resultadoCliFor = res.data})         
              .catch(showError)                                
      }, 
      


      postclifors() {
       //const partesData = this.resultadocnpj.abertura.split('/');    
        // Reorganizar as partes da data no formato YYYY-MM-DD
        //const dataFormatada = `${partesData[2]}-${partesData[1]}-${partesData[0]}`;

            let corpo = {    
              "id_funcionario": `${this.user.id_funcionario}`,                                           
              "empresa_id": `${this.user.id_empresa}`,   
                "id": `${this.resultadocnpj.id}`,                                           
                "abertura": `${this.resultadocnpj.abertura}`,                                           
                "situacao": `${this.resultadocnpj.situacao}`,                                           
                "tipo": `${this.resultadocnpj.tipo}`,                                                             // pegar o valor da filial     
                "nome": `${this.resultadocnpj.nome}`,                                                                     // ERP terceiro deverá passar             
                "fantasia": `${this.resultadocnpj.fantasia}`,                                           
                "porte": `${this.resultadocnpj.porte}`,
                "natureza_juridica": `${this.resultadocnpj.natureza_juridica}`,
                "logradouro": `${this.resultadocnpj.logradouro}`,
                "numero": `${this.resultadocnpj.numero}`,
                "municipio": `${this.resultadocnpj.municipio}`,                
                "bairro": `${this.resultadocnpj.bairro}`,
                "uf": `${this.resultadocnpj.uf}`,
                "cep": `${this.resultadocnpj.cep}`,
                "email": `${this.resultadocnpj.email}`,
                "telefone": `${this.resultadocnpj.telefone}`,                                                                //empresa
                "celular": `${this.resultadocnpj.celular}`,                                                                //empresa
                "data_situacao": `${this.resultadocnpj.data_situacao}`,
                "cnpj": `${this.resultadocnpj.cnpj}`,
                "status": `${this.resultadocnpj.status}`,
                "complemento": `${this.resultadocnpj.complemento}`,
                "capital_social": `${this.resultadocnpj.capital_social}`,
                "site": `${this.resultadocnpj.site}`,
                "contato": `${this.resultadocnpj.contato}`,
                "tipo_id": `${this.resultadocnpj.tipo_id}`,
                "area_id": `${this.resultadocnpj.area_id}`,
                "escritorio_id": `${this.resultadocnpj.escritorio_id}`
            };
          const url = `${baseApiUrl}/jb/fin/cliforcad`
            axios.post(url,corpo)
            .then(() => {                                                  
                    this.loadCliGrid(),
                    this.$toasted.global.defaultSuccess()
                  })
            .catch(showError)
      }, 

      
      reset() {                  
            //this.resultadocnpj = []                     
      },      
    },

    watch: {
      page() {
        this.loadVeiculos()
      }
    },

    mounted() {  
      this.loadEmpresas()
      this.loadArea()
      this.loadTipo()      
      this.loadEscritório()
      this.loadCliGrid()      
      /*
      this.loadFiliais()
      this.loadVeiculos() 
      this.loadFabricanteChassi()            
      this.loadModeloChassi()
      this.loadcliforStatus()
      this.loadCarroceriaFabricante()
      this.loadCarroceriaModelo()     
      this.loadTipoFrota()
      this.loadLote()
      */

      
    },
}

</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>

#selecaostatusx{
    font-size: 0.7em;      
}

</style>
